import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdvisorGuard implements CanActivate {
  constructor(
    private router: Router,
    private storageService: StorageService,
    private authService: AuthService
  ) {}

  baseUrl = "";

	common_url: any = environment.apiEndpoint;
	deposit_growth_url: any = environment.apiEndpoint + "/deposits";
	lending_growth_url: any = environment.apiEndpoint + "/lending";
	insurance_growth_url: any = environment.apiEndpoint + "/insurance";


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const user = this.storageService.get('user_details');

    if (user) {

			if (
				user.role.role == 4 ||
				user.role.role == 5 ||
				user.role.role == 6 ||
				user.role.role == 7 ||
				user.role.role == 8 ||
				user.role.role == 12 ||
				user.role.role == 13 ||
				user.role.role == 14
			) {

				if (user.role.business_area[0] == 5) {
					this.baseUrl = this.common_url;
				} else if (user.role.business_area[0] == 6) {
					this.baseUrl = this.deposit_growth_url;
				} else if (user.role.business_area[0] == 7) {
					this.baseUrl = this.lending_growth_url;
				} else if (user.role.business_area[0] == 8) {
					this.baseUrl = this.insurance_growth_url;
				}

			} else {
				this.baseUrl = this.common_url;
			}
		} else {
			this.baseUrl = this.common_url;
		}


    // if (user.role.group.category == 4 && user.is_afa == false) {
      const redirectUrl = state.url;
      if (user) {
        if ((user.role.role == 5)) {
          return true;
        }

        // Redirect to home page or an error page
        this.authService.setReturnUrl(redirectUrl);
        this.router.navigate(['/login']);
        // this.authService.logout();
        return false;
      } else {
        this.authService.setReturnUrl(redirectUrl);
        this.router.navigate(['/login']);
        // this.authService.logout();
        return false;
      }

    // Redirect to home page or an error page
    // this.router.navigate(['/login']);
    // this.authService.logout();
    // return false;
  }
}
